// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"588":"7cce14f97a488ef46df9","767":"d8641068158c2c8a8e4c","797":"5c491001316feff24184","976":"167151d65b7b9083663c"}[chunkId] + ".chunk.js";
};